import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { Button, Select, Input, Layer, InputRed, InputX } from 'components'
import { showMyInfoNumberState, userLogInfoState, showMyInfoNumberCertState } from 'views/member/states'
import { useRecoilState, useSetRecoilState } from 'recoil'
import Lib from 'library'
import MyInfoNumberCert from './MyInfoNumberCert'

const MyInfoNumber = () => {

	const App = useApp()
	const [showMyInfoNumber, setShowMyInfoNumber] = useRecoilState(showMyInfoNumberState)
	const setUserInfo = useSetRecoilState(userLogInfoState)
	const setShowMyInfoNumberCert = useSetRecoilState(showMyInfoNumberCertState)

	const [buttonDisabled, setButtonDisabled] = useState(false) // 메인버튼 disabled 여부

	const [data, setData] = useState()
	const [telecomList, setTelecomList] = useState()
	const [telCom, setTelCom] = useState(App.user?.tcomCd ?? null)
	const [phoneNum, setPhoneNum] = useState(App.user?.cphNo ?? "")
	const [userName, setUserName] = useState(App.user?.mbNm ?? "")
	const [socialNum1, setSocialNum1] = useState(App.user?.birthDe ? App.user?.birthDe.replace(/-/g, "").substr(2) : "")
	const [socialNum2, setSocialNum2] = useState(() => {
		const gender = App.user?.gendr
		const birth1 = App.user?.birthDe?.substr(0, 1)
		let social2
		if (gender === "M") {
			if (birth1 === "1") {
				social2 = "1"
			} else if (birth1 === "2") {
				social2 = "3"
			}
		} else {
			if (birth1 === "1") {
				social2 = "2"
			} else if (birth1 === "2") {
				social2 = "4"
			}
		}
		return social2
	})

	const [phoneRed, setPhoneRed] = useState(false)
	const [nameRed, setNameRed] = useState(false)


	const getTelecomList = async () => {
		const list = await Lib.getCommonCode("TCOM")
		if (!list) {
			setTelecomList([
				{
					key: "SKT",
					value: "SKT"
				},
				{
					key: "KT",
					value: "KT"
				},
				{
					key: "LGU+",
					value: "LGT"
				},
				{
					key: "SKT 알뜰폰",
					value: "SKM"
				},
				{
					key: "KT 알뜰폰",
					value: "KTM"
				},
				{
					key: "LGU+ 알뜰폰",
					value: "LGM"
				},
			])
		} else {
			setTelecomList(list.map(item => {
				return {
					key: item.commNm,
					value: item.commCd
				}
			}))
		}
	}

	const validate = () => {
		if (Lib.isNull(telCom)) {
			return false
		}

		if (Lib.isNull(phoneNum) || !(/^\d{10,11}$/.test(phoneNum))) {
			setPhoneRed(true)
			return false
		} else {
			setPhoneRed(false)
		}

		if (Lib.isNull(userName) || /[^가-힣]|^$/.test(userName)) {
			setNameRed(true)
			return false
		} else {
			setNameRed(false)
		}

		return true
	}

	useEffect(() => {
		setButtonDisabled(!validate())

	}, [telCom, phoneNum, userName])

	const onPhoneNumChange = e => {
		let value
		if (!e) { value = "" } else { value = e.target.value }
		setPhoneNum(value)
	}

	const onUserNameChange = e => {
		let value
		if (!e) { value = "" } else { value = e.target.value }
		setUserName(value)
	}

	//레이어 이동 방법
	const onButton = () => {

		setUserInfo(info => {
			return {
				...info,
				cphNo: phoneNum,
				nm: userName,
				rsdtRegNo: `${socialNum1}${socialNum2}`,
				tcomCd: telCom
			}
		})

		Lib.post({
			url: `/api/more/myinfo/auth/req`,
			data: {
				cphNo: phoneNum,
				nm: userName,
				rsdtRegNo: `${socialNum1}${socialNum2}`,
				tcomCd: telCom
			},
			onSuccess: data => {
				setShowMyInfoNumberCert(true)
				//App.alert("성공!")
			},
			onFail: res => {
				App.alert("개인정보를 정확하게 입력하세요")
			},
			onError: error => {
				App.alert("개인정보를 정확하게 입력하세요")
			}
		})

	}

	useEffect(() => {
		getTelecomList()
		if (showMyInfoNumber === true) {
			setTelCom(App.user?.tcomCd ?? null)
			setPhoneNum(App.user?.cphNo ?? "")
			setUserName(App.user?.mbNm ?? "")
		}
	}, [showMyInfoNumber])

	return (
		<Layer show={showMyInfoNumber} closeLayer={() => setShowMyInfoNumber(false)}>
			<div className="page">
				<div className="flex_1 padding">
					<h3>이름 및 휴대폰번호를<br />변경하려면 본인인증이 필요해요.</h3>

					<p className="guide-title mt_40">휴대폰번호</p>
					<div className="flex-align_center mt_10">
						<Select placeholder="선택" title="통신사" style={{ width: "8rem" }} selected={telCom} data={telecomList} onSelect={(key, value) => {
							setTelCom(value)
						}}>
						</Select>
						<Input type="text" value={phoneNum} onChange={onPhoneNumChange} id="" className="flex--item_1 ml_20" maxlength="11" />
					</div>
					<InputRed text="숫자 10~11자로 입력해주세요." show={phoneRed} />

					<p className="guide-title mt_40">주민등록번호</p>
					<div className="flex-align_center mt_10" style={{ position: "relative" }}>
						<Input readOnly type="text" defaultValue={socialNum1} id="" className="flex--item_1" maxlength="6" />
						<span style={{ margin: "0 0.5rem" }}>-</span>
						<div className="flex--item_1">
							<Input readOnly type="text" id="" defaultValue={socialNum2} style={{ width: "3rem", paddingRight: 0, textAlign: "center" }} maxlength="1" />
							<div className="floating-dots">
								<span />
								<span />
								<span />
								<span />
								<span />
								<span />
							</div>
						</div>
					</div>

					<p className="guide-title mt_40">이름</p>
					<Input type="text" setValue={setUserName} value={userName} id="" name="" className="mt_10" onChange={onUserNameChange} />
					<InputRed text="한글로만 입력해주세요." show={nameRed} />
				</div>
				<div className="flex-shrink_0 padding">
					<Button className="btn btn--big" onClick={onButton} disabled={buttonDisabled}>다음</Button>
				</div>
			</div>

			<MyInfoNumberCert />

		</Layer>
	)
}

export default MyInfoNumber
